import { painPoints } from '@/content/site';
import { ScrollReveal } from '@/components/ScrollReveal';
import { Section } from '@/components/Section';
import './PainPoints.css';

type PainPointsProps = {
  /** Override del href del CTA inferior (p. ej. `#contacto` en landing mobile). */
  ctaHref?: string;
  /** Oculta el botón CTA (en mobile el único CTA es el sticky). */
  hideCta?: boolean;
};

export function PainPoints({ ctaHref, hideCta = false }: PainPointsProps) {
  const href = ctaHref ?? painPoints.cta.href;

  return (
    <Section id="problemas" title={painPoints.title} lead={painPoints.lead} className="pain-section">
      <div className="pain-grid">
        {painPoints.items.map((item, i) => (
          <ScrollReveal key={item.title} delay={i * 80}>
            <article className="glass-card pain-card">
              <span className="pain-card__icon" aria-hidden="true">
                {item.icon}
              </span>
              <h3>{item.title}</h3>
              <p>{item.body}</p>
              <span className="pain-card__cost">{item.costLabel}</span>
            </article>
          </ScrollReveal>
        ))}
      </div>
      {hideCta ? (
        <ScrollReveal>
          <div className="pain-cta">
            <p className="pain-cta__text">{painPoints.cta.text}</p>
          </div>
        </ScrollReveal>
      ) : (
        <ScrollReveal>
          <div className="pain-cta">
            <p className="pain-cta__text">{painPoints.cta.text}</p>
            <a href={href} className="btn btn-primary">
              {painPoints.cta.button}
            </a>
          </div>
        </ScrollReveal>
      )}
    </Section>
  );
}
